// Vendors
import React, { useState, useEffect } from 'react';

// Child component
import TopCheckbox from './TopCheckbox';

const NestedCheckboxes = ({
  data,
  selectedProjectIDs,
  handleSelectProject,
  ...props
}) => {
  const builder = data[0];
  const projects = data[1];
  const projectIDs = data[1].map((project) => project.pid);
  const [checkboxValue, setCheckboxValue] = useState(0);

  useEffect(() => {
    if (!selectedProjectIDs.length) {
      setCheckboxValue(0);
      return;
    }

    if (projectIDs.every((pid) => selectedProjectIDs.includes(pid))) {
      setCheckboxValue(1);
    } else if (selectedProjectIDs.some((pid) => projectIDs.includes(pid))) {
      setCheckboxValue(-1);
    }
  }, [selectedProjectIDs]);

  return (
    <ul>
      <li>
        <label className="form__checkbox form__checkbox--sm u--margin-top-0">
          <TopCheckbox
            value={checkboxValue}
            projectIDs={projectIDs}
            {...props}
          />{' '}
          {builder}
        </label>
        <ul>
          {projects.map(({ pid, address, status }, index) => {
            return (
              <li key={index}>
                <label className="form__checkbox form__checkbox--sm u--margin-top-0">
                  <input
                    type="checkbox"
                    checked={
                      selectedProjectIDs !== undefined &&
                      selectedProjectIDs.includes(pid)
                    }
                    onChange={() => handleSelectProject(pid)}
                  />{' '}
                  {address} - [{status}]
                </label>
              </li>
            );
          })}
        </ul>
      </li>
    </ul>
  );
};

export default NestedCheckboxes;
